module.exports = __webpack_public_path__ + "static/media/export-svg.c3c26716.png";